"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhoneInfoCms = void 0;
var PhoneInfoCms = /** @class */ (function () {
    function PhoneInfoCms() {
        this.verifyMobileChkboxLabel = 'This is a mobile number';
        this.verifyMobileChkboxLabelSMB = 'This number is a mobile number';
        this.smbPhoneNumberConsentChkboxLabel = 'By checking this box you authorize AT&T to reach you by phone or text with information about your AT&T services. Examples include install and repair appointments, billing and account information, and customer satisfaction inquiries. Standard rates may apply.';
        this.mobileAlertConsentLabel = "By adding a contact number, you may receive a call or text\n    about your AT&T installation appointment.To opt out of future communications\n    , please call 800.288.2020. If you are not an AT&T mobile consumer, text message rates other charges\n    may apply depending on your plan and provider.";
        this.mobileAlertConsentLabelSMB = "By adding a mobile number, you may receive a call or text about your\n    AT&T installation appointment. To opt out of future communications, call 800.288.2020. If you aren\u2019t\n    an AT&T mobile customer, text message rates and other charges may apply depending on your plan and provider.\u201D";
    }
    return PhoneInfoCms;
}());
exports.PhoneInfoCms = PhoneInfoCms;
//# sourceMappingURL=PhoneInfo.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/panels/ScheduleInstallPanel/PhoneInfo/PhoneInfo.cms.js
// module id = 965
// module chunks = 8